export enum ResponseCodeEnum {
  CODE_SUCCESS,
  CODE_PERMISSION,
  CODE_NOT_FOUND,
  CODE_ALREADY_EXIST,
  CODE_BUSINESS,
  CODE_EXPIRED = 8888,
  CODE_INTERNAL_ERROR = 9999,
  CODE_BAD_REQUEST = 400,
}
